import React, { useState, useEffect } from 'react';
import { MainPageContainer } from './styled';
import main1 from "../../images/main/main-1.jpg"
import main2 from "../../images/main/main-2.jpg"
import main3 from "../../images/main/main-3.jpg"

function MainPage() {

    const imgList = [main1, main2, main3];
    const length = imgList.length;

    const [imgIdx, setImgIdx] = useState(0);

    useEffect(() => {
        const newIdx = (imgIdx+1) % length;
        const interval = setInterval(() => {
            setImgIdx(newIdx);
        }, 5000);
        return () => clearInterval(interval);
      }, [imgIdx]);

    return (
        <MainPageContainer>
            <img src={imgList[imgIdx]} alt="" />
        </MainPageContainer>
    );
}

export default MainPage;